import { baseUrl } from "./base-service";

export async function Login(email: string, password: string): Promise<string> {

    const body = {
        email: email,
        password: password
    };

    const response = await fetch(`${baseUrl}/users`, {
        method: 'POST',
        body: JSON.stringify(body),
        headers: {
            'content-type': 'application/json',
            'accept': 'application/json'
        }
    });

    return response.json();
}